import { ComponentChildren } from 'preact';
import { Flex } from '../UNSAFE_Flex';
import { Layer } from '../UNSAFE_Layer';
import { WindowOverlay } from '../UNSAFE_WindowOverlay';
import { mobileDropdownStyles } from './themes/mobileDropdownStyles.css';

type Props = {
  /**
   * The dropdown content
   */
  children?: ComponentChildren;

  /**
   * The id for the top level element
   */
  id?: string;

  /**
   * Specifies whether the dropdown is being shown
   */
  isOpen?: boolean;
};

export function MobileDropdown({ children, id, isOpen }: Props) {
  return !isOpen ? null : (
    <Layer>
      <WindowOverlay>
        <div id={id} class={mobileDropdownStyles.base} role="dialog" aria-modal="true">
          <Flex width="100%" height="100%" maxHeight="100%" direction="column">
            {children}
          </Flex>
        </div>
      </WindowOverlay>
    </Layer>
  );
}
